import { FunctionComponent } from 'react';
import { TITLE_TEXT, TockDialog } from 'omakase';

interface PatronLocationDialogProps {
  onClose(): void;
  open: boolean;
}

export const PatronLocationDialog: FunctionComponent<PatronLocationDialogProps> = ({
  children,
  onClose,
  open,
}) => {
  return (
    <TockDialog
      disablePadding
      aria-labelledby={TITLE_TEXT}
      onClose={onClose}
      open={open}
      type="fullScreen"
      fullHeight
      headingConfig={{
        left: {
          configType: 'title',
          title: 'Where are you located?',
        },
        right: {
          configType: 'closeButton',
        },
      }}
    >
      {children}
    </TockDialog>
  );
};
